import React, { useState } from "react";
import BookTabInfo from "../../BookModule.module.css";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import ListIndividualsBooks from "./ListIndividualsBooks";
import ListBookSets from "./ListBookSets";
import ListPreOrder from "./ListPreOrder";
import { clearBookFilters } from "../../../../../../redux/purchaseBookFilterSlice";
import { useDispatch } from "react-redux";

export default function BookTab() {
  const navigate = useNavigate();
  const { active_tab } = useParams();
  const [activeTab, setActiveTab] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    setActiveTab(Number(active_tab) || 1);
  }, [active_tab]);
  // useEffect(() => {
  //   dispatch(clearBookFilters());
  // }, [])
  const handleTabClick = (index) => {
    setActiveTab(index);
    navigate(`/studyMaterials/Books/List/${index}`);
    dispatch(clearBookFilters());
  };
  return (
    <div className={` BathHeader golbal_container`}>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h2 className="TitleHeader">Books</h2>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 1 ? "nav-link active" : "nav-link"}
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-1"
                aria-selected={activeTab === 1}
                onClick={() => handleTabClick(1)}
              >
                Individual Books
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 2 ? "nav-link active" : "nav-link"}
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-2"
                aria-selected={activeTab === 2}
                onClick={() => handleTabClick(2)}
              >
                Booksets
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 3 ? "nav-link active" : "nav-link"}
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-3"
                aria-selected={activeTab === 3}
                onClick={() => handleTabClick(3)}
              >
                Pre-Orders
              </a>
            </li>
          </ul>
        </div>
      </div>

      {activeTab === 1 && <ListIndividualsBooks />}
      {activeTab === 2 && <ListBookSets />}
      {activeTab === 3 && <ListPreOrder />}
    </div>
  );
}
